import { render, staticRenderFns } from "./FNSVFooter.vue?vue&type=template&id=5ab9b866&scoped=true"
var script = {}
import style0 from "./FNSVFooter.vue?vue&type=style&index=0&id=5ab9b866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9b866",
  null
  
)

export default component.exports